import { useBaseApiQuery } from "@query/baseQuery";

export const DASHBOARD_GRAPH_PERIODS = [
  "1year",
  "6months",
  "3months",
  "1month",
  "1week",
];

export const DEFAULT_DASHBOARD_GRAPH_PERIOD = "1month";

export const useInvestmentGraphQuery = (period = DEFAULT_DASHBOARD_GRAPH_PERIOD) => {
  return useBaseApiQuery(
    {
      endpoint: "/graph/me/investment",
      params: { period },
    },
    {
      queryKey: ["dashboard", "graph", "investment", period],
      enabled: Boolean(period),
    }
  );
};

export const useHourlyActivityAverageGraphQuery = (
  period = DEFAULT_DASHBOARD_GRAPH_PERIOD
) => {
  return useBaseApiQuery(
    {
      endpoint: "/graph/me/activity/hourly-average",
      params: { period },
    },
    {
      queryKey: ["dashboard", "graph", "hourly-average", period],
      enabled: Boolean(period),
    }
  );
};

export const useDailyActivityUsersGraphQuery = (
  period = DEFAULT_DASHBOARD_GRAPH_PERIOD
) => {
  return useBaseApiQuery(
    {
      endpoint: "/graph/me/activity/daily-users",
      params: { period },
    },
    {
      queryKey: ["dashboard", "graph", "daily-users", period],
      enabled: Boolean(period),
    }
  );
};
